const t = "af.library-follow", s = class s extends CustomEvent {
  constructor(o) {
    super(t, { detail: o, bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = t;
let e = s;
export {
  t as EVENT_NAME,
  e as default
};
//# sourceMappingURL=LibraryFollowEvent.js.map
